import { useState, useEffect } from 'react';
import ToggleForm from '../../components/toggle/ToggleForm';
import { filterUndefined } from '../../utils/FilterUndefinedObject';

const defaultProps = {
  profile: {},
  onChangeCallback: () => {},
};

const StudentSettingOption = (props) => {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { profile, onChangeCallback } = mergedProps;
  const [toggle, setToggle] = useState(profile.studentSettings);

  // When mounting and changing a student.
  useEffect(() => {
    setToggle(profile.studentSettings);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile.id]);

  const handleOnchange = (_field, newValue) => {
    if (newValue === null) return;
    setToggle(newValue);
    onChangeCallback(newValue);
  };

  return (
    <ToggleForm value={toggle} handleOnChange={handleOnchange} data-test='student-settings-toggle' />
  );
};

export default StudentSettingOption;
